export const VersionInfo = {
  gitTag: "%%GIT_TAG%%",
  gitHash: "%%GIT_HASH%%",
  gitTagDistance: "%%GIT_TAG_DISTANCE%%",
  gitDirty: "%%GIT_DIRTY%%",
  gitTagFull: "%%GIT_TAG_FULL%%",
  gitRevision: "%%GIT_REVISION%%",
};
